import React from "react";
import BlaboUser, { blaboUserDefault } from "./BlaboUser";


export default React.createContext<{user: BlaboUser, update: (values: any) => void}>({user: blaboUserDefault, update: (values: any) => {}});

